import { useState, useEffect } from 'react';
import { useMascot } from '@/contexts/mascot-context';

interface HaasTooltipProps {
  storageKey: string;
  message: string;
  children?: React.ReactNode;
}

export default function HaasTooltip({ storageKey, message, children }: HaasTooltipProps) {
  const [visible, setVisible] = useState(false);
  const { haasEnabled } = useMascot();

  useEffect(() => {
    if (!haasEnabled) return;
    const seen = localStorage.getItem(storageKey);
    if (!seen) {
      setVisible(true);
    }
  }, [storageKey, haasEnabled]);

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem(storageKey, 'true');
  };

  if (!visible) return children ? <>{children}</> : null;

  return (
    <>
      {children}
      <div className="fixed bottom-28 right-4 sm:bottom-28 sm:right-4 z-50 flex flex-col sm:flex-row items-center sm:items-end gap-3 max-w-sm animate-in fade-in slide-in-from-bottom-4 duration-300">
        <img
          src="/haas/haas-guide.png"
          alt="Haas guide"
          className="w-[130px] h-[130px] flex-shrink-0 object-contain drop-shadow-lg"
        />
        <div className="bg-white rounded-2xl shadow-xl border border-indigo-100 p-5 relative">
          <button
            onClick={dismiss}
            className="absolute top-2.5 right-2.5 text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Dismiss tooltip"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
          </button>
          <p className="text-[15px] leading-relaxed text-gray-700 whitespace-pre-line pr-5">
            {message}
          </p>
        </div>
      </div>
    </>
  );
}
